import { useCallback, useContext } from 'react'
import Context from '../context/index'
export type QueryParams = {
  networkNumber: string
}

type GetTokenFunction = () => Promise<string>

// NOTE to remember, this hook is mocked in jest.setup.ts for all the test suits
// otherwise in every components that require token, they will need to be wrapped within the <Router>
// execpt we are not mocking this hook useGetToken.test.txs ( which we actually test this hook)
export const useGetToken = (): [GetTokenFunction] => {
  const { acquireToken } = useContext(Context)

  // Memoised on `acquireToken` so the returned function keeps its identity
  // between renders. Callers put it in useCallback/useEffect dependency arrays;
  // a fresh function every render makes those effects re-run on every render,
  // and any effect that sets state then re-triggers itself in a loop.
  // `acquireToken` is context state, so this still produces a new function -
  // and so re-runs those effects - once a token provider becomes available.
  const getAccessToken = useCallback(async () => {
    if (acquireToken) {
      const response = await acquireToken(true)
      const token = response ? `Bearer ${response.accessToken}` : ''
      return token
    } else {
      console.error(
        'There is no acquireToken in context while trying to get token for KONE employee',
      )
      return Promise.resolve('')
    }
  }, [acquireToken])

  return [getAccessToken]
}
